import React from 'react';
import {Link} from 'gatsby';
import {LazyLoadImage} from "react-lazy-load-image-component";
import logo1 from "../../images/services-usa/custom/case-logo-1.webp";
import logo2 from "../../images/services-usa/custom/case-logo-2.webp";
import logo3 from "../../images/services-usa/custom/case-logo-3.webp";
import Img1 from "../../images/services-usa/custom/case-study-1.webp";
import Img2 from "../../images/services-usa/custom/case-study-2.webp";
import Img3 from "../../images/services-usa/custom/case-study-3.webp";
import {Case_Arrow , Case_ArrowCustomusa} from '../../../app-constants';

const Caseusa1 = () => {
  return (
    <section className="case_flex">
    <div className="flex_item" style={{ backgroundColor: '#1A5DAD'}}> 
      <div className="case_txt">
        <div className="case_logo">
          <LazyLoadImage
            src={logo1}
            effect="blur"
            alt="tekrevol_android"
            className="img-fluid"
          />
        </div>
        <div className="case_title">
          <h3>Waste Connections RMO</h3>
          <Link
            to="/case-studies/waste-connections-rmo"
            className="case-usabtn"
            aria-label="TekRevol Contact"
          >
            View Case Study {Case_Arrow}
          </Link>
        </div>
      </div>
      <div className="case_figure">
        <LazyLoadImage
          src={Img1}
          effect="blur"
          alt="tekrevol_android"
          className="img-fluid"
        />
      </div>
    </div>
    <div className="flex_item" style={{ backgroundColor: '#F3F3F3'}}>
      <div className="case_txt">
        <div className="case_logo">
          <LazyLoadImage
            src={logo2}
            effect="blur"
            alt="tekrevol_android"
            className="img-fluid"
          />
        </div>
        <div className="case_title">
          <h3 style={{ color: '#0047BA'}}>The S.E.L.F App by Project Impact MS</h3>
          <Link
            to="/case-studies/impact"
            className="case-usabtn"
            aria-label="TekRevol Contact" style={{ color: '#0047BA'}}
          >
            View Case Study {Case_ArrowCustomusa}
          </Link>
        </div>
      </div>
      <div className="case_figure website">
        <LazyLoadImage
          src={Img2}
          effect="blur"
          alt="tekrevol_android"
          className="img-fluid"
        />
      </div>
    </div>
    <div className="flex_item" style={{ backgroundColor: '#01043F'}}>
      <div className="case_txt">
        <div className="case_logo">
          <LazyLoadImage
            src={logo3}
            effect="blur"
            alt="tekrevol_android"
            className="img-fluid"
          />
        </div>
        <div className="case_title">
          <h3>A Inventory Management and Product Supplies Business Portal</h3>
          <Link
            to="/case-studies/stock-ship"
            className="case-usabtn"
            aria-label="TekRevol Contact"
          >
            View Case Study {Case_Arrow}
          </Link>
        </div>
      </div>
      <div className="case_figure website">
        <LazyLoadImage
          src={Img3}
          effect="blur"
          alt="tekrevol_android"
          className="img-fluid"
        />
      </div>
    </div>
  </section>
  )
}

export default Caseusa1